<template>
  <div class="form-group">
    <div id="mailinfo" class="box" style="display: none"></div>
    <iframe
      sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
      width="100%"
      height="800px"
      style="border: 0; overflow: hidden; overflow-x: auto"
      src="https://forms.helpdesk.com?licenseID=818528430&caption=Need%20help%20with%20our%20proxies%20or%20have%20something%20else%20to%20say%3F%20Please%20contact%20us%20here!%0APlease%20make%20sure%20to%20include%20relevant%20information%20such%20as%20your%20account%20key%20or%20order%20ID.&header=Contact%20us&confirmation=Thank%20you!%20We%E2%80%99ll%20contact%20you%20as%20soon%20as%20possible.&teamID=80762600-cc36-40c7-9f4c-b2f5f8c44846"
    >
      Your browser does not allow embedded content.
    </iframe>
    <p>
      or e-mail directly to
      <a href="mailto:support@proxyscrape.com" style="text-decoration: underline"
        >support@proxyscrape.com</a
      >
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
